<script setup lang="ts">
interface Props {
  title?: string
  badge?: number | string
  ui?: {
    wrapper?: string
    title?: string
  }
}
const props = withDefaults(defineProps<Props>(), {
  ui: () => ({})
})
</script>

<template>
  <header
    class="flex items-center justify-between gap-4 px-4 py-3 border-b border-gray-200 bg-white"
    :class="props.ui?.wrapper"
  >
    <div class="flex items-center gap-3 min-w-0">
      <slot name="left" />
      <div v-if="title" class="flex items-center gap-2">
        <h1 class="text-lg font-semibold text-gray-900 truncate" :class="props.ui?.title">
          {{ title }}
        </h1>
        <span v-if="badge" class="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700">
          {{ badge }}
        </span>
      </div>
      <slot name="title" />
    </div>
    <div class="flex items-center gap-2">
      <slot name="right" />
      <slot />
    </div>
  </header>
</template>
